<template>
  <div class="container">
    <div class="oferta-container padding-17-left-right">
      <wrap-container class="w100 grid-container grid-container--6-6">
        <wrap-container class="col1 main-title">
          <span class="titles">
            <p id="titulo" class="titulo p28 oscuro">
              ¡Hola <span data-obfuscate>{{ nombre }}</span
              >!
            </p>
            <p id="subtitulo" class="titulo p32 oscuro medium">
              {{ config.pasos.clienteCA.titulo }}
            </p>
          </span>
        </wrap-container>
      </wrap-container>
      <wrap-container class="cascade w50">
        <img
          class="image"
          src="@/assets/img/ofertaNomina/devices.png"
          alt="Dispositivos"
        />
        <p class="description">
          {{ config.pasos.clienteCA.descripcion }}
        </p>
        <sales-button
          class="sales-button"
          ref="salesbutton"
          label="Ir a Banca Online"
          @click.native="goToHomeBanking"
        />
      </wrap-container>
      <wrap-container class="cascade w50">
        <offer-group
          class="offer-group"
          :label="config.pasos.clienteCA.beneficiosTitulo"
        >
          <offer-element
            v-for="inc in config.pasos.clienteCA.beneficios"
            v-bind:key="inc.label"
            :label="inc.label"
            :description="inc.description"
          />
        </offer-group>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferGroup from "@/components/core/OfferGroup";
import OfferElement from "@/components/core/OfferElement";
import SalesButton from "@/components/core/SalesButton";
import { DO_INGRESO_BANCA_ONLINE } from "../config/constants/action-types";

export default {
  name: "ClienteCA",
  components: {
    WrapContainer,
    OfferGroup,
    OfferElement,
    SalesButton
  },
  methods: {
    goToHomeBanking() {
      this.$store.dispatch(DO_INGRESO_BANCA_ONLINE);
      window.open(
        "https://www.bbva.com.ar/fnetcore/loginClementeApp.html?init=acc",
        "Login",
        "noopener"
      );
    }
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    }
  }
};
</script>
<style scoped>
.container {
  margin-top: 20px;
  margin-bottom: 50px;
}
div.container {
  height: 100%;
}
.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}
div.oferta {
  display: block;
  max-width: 550px;
}
p {
  margin-top: 0px;
  margin-bottom: 0px;
}
p#subtitulo {
  margin-bottom: 0px;
  max-width: 500px;
}
.image {
  display: block;
  width: 141px;
  margin-bottom: 8px;
}
.description {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.29px;
  color: #121212;
  width: 450px;
  margin-bottom: 32px;
}
.sales-button {
  margin-bottom: 32px;
  width: 216px;
}

@media screen and (max-width: 599px) {
  .container {
    margin-top: 0px;
  }
  #titulo {
    font-size: 20px;
    margin-bottom: 8px;
  }
  #subtitulo {
    font-size: 26px;
    margin-bottom: 4px;
  }
  .p#titulo {
    text-align: center;
  }
  .p#subtitulo {
    text-align: center;
  }
  .image {
    width: 146px;
    margin-left: calc(50% - 73px);
    margin-top: -20px;
  }
  .description {
    width: 100%;
    margin-bottom: 24px;
    text-align: center;
  }
  .offer-group {
    margin-top: 32px;
  }
  .titles {
    display: inline;
    text-align: center;
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .main-title {
    width: 200%;
  }
  .titles {
    display: inline;
    text-align: center;
  }
  p#subtitulo {
    max-width: 100%;
  }
  .container {
    margin-top: 0px;
  }
  .sales-button {
    max-width: 100%;
    text-align: center;
  }
  .offer-group {
    margin-left: 20px;
  }
  .description {
    width: 100%;
  }
  .image {
    margin-left: calc(50% - 70px);
  }
}
</style>
